module.exports = __webpack_public_path__ + "images/bdaef02e9ae4874b40f97e120e6ec22f.svg";